import { TYPE_STRING } from './input-types';

export const id = 'rmaNumber';
export const apiKey = 'rmaNumber';
export const type = TYPE_STRING;

export const rmaNumber = {
  id,
  apiKey,
  type,
};
